import { TextField, Button, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import currency from 'currency.js'
import React, { useEffect, useState } from 'react'
import { TextMaskDollaBills } from './InputMasks'

import { submitGift } from '../../api/api'
import { normalizeErrorResponse } from '../../util/errorUtils'
import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'
import { Submitting } from '../common/Submitting'

const useStyles = makeStyles(theme => ({
  inputRoot: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  applyButton: {
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    height: 40,
  },
}))

const RemoveAppliedGift = ({
  applyGift,
  loading,
  storedCurrencyBalance,
  storedCurrencyBalanceUsed,
}) => {
  return (
    <div className="Input Input--attached">
      <label htmlFor="gift">Gift Applied</label>
      <div className="Input--attachedSet ">
        <p className="Input-mockInput">
          {currency((storedCurrencyBalanceUsed / 100).toFixed(2), {
            formatWithSymbol: true,
          }).format()}
        </p>

        {loading ? (
          <Submitting text="Changing" />
        ) : (
          <Button
            className="button secondary"
            onClick={e => {
              e.preventDefault()
              applyGift(0)
            }}
            type="button"
          >
            Change
          </Button>
        )}
      </div>
      {storedCurrencyBalance ? (
        <label htmlFor="gift">
          Total gift balance available:{' '}
          {currency(
            (storedCurrencyBalance / 100).toFixed(2) - (storedCurrencyBalanceUsed / 100).toFixed(2),
            {
              formatWithSymbol: true,
            },
          ).format()}{' '}
        </label>
      ) : null}
    </div>
  )
}

const AddGift = ({ applyGift, loading, setValue, storedCurrencyBalance, value, error }) => {
  const classes = useStyles()
  return (
    <Box display="flex" alignItems="flex-start">
      <TextField
        label="Gift Amount"
        fullWidth
        variant="outlined"
        color="secondary"
        size="small"
        InputProps={{
          classes: {
            root: classes.inputRoot,
          },
          inputComponent: TextMaskDollaBills,
        }}
        onBlur={() =>
          pushSnowplow(toOrderProcessSchema('daily', 'checkout_gift_amount_enter', value))
        }
        onKeyDown={e => {
          if (e.keyCode === 13) {
            e.preventDefault()
            applyGift(value)
          }
        }}
        onChange={val => setValue(val)}
        value={value}
        error={error}
        helperText={
          error ||
          `Total credits available: ${currency(storedCurrencyBalance / 100, {
            formatWithSymbol: true,
          }).format()}`
        }
      />
      <Button
        variant="contained"
        disableElevation
        color="secondary"
        classes={{ root: classes.applyButton }}
        disabled={loading}
        onClick={event => {
          event.preventDefault()
          applyGift(value)
        }}
      >
        Apply
      </Button>
    </Box>
  )
}

export const Gifts = ({
  dropoffId,
  isSubscribed,
  loadCheckoutCartStart,
  orderTotal,
  storedCurrencyUsage,
}) => {
  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const applyGift = async giftAmount => {
    setLoading(true)
    try {
      pushSnowplow(
        toOrderProcessSchema('daily', 'checkout_gift_amount_apply', currency(giftAmount).intValue),
      )
      await submitGift(dropoffId, currency(giftAmount).intValue)
      loadCheckoutCartStart(dropoffId, isSubscribed)
      setError(null)
    } catch (e) {
      const error = normalizeErrorResponse(e)
      setError(error)
      pushSnowplow(
        toOrderProcessSchema(
          'daily',
          'checkout_gift_amount_apply',
          currency(giftAmount).intValue,
          error,
        ),
      )
    }
    setLoading(false)
  }

  useEffect(() => {
    setValue(Math.min(storedCurrencyUsage?.storedCurrencyBalance / 100, orderTotal))
  }, [orderTotal, storedCurrencyUsage])

  return (
    <Box mb={3}>
      {storedCurrencyUsage?.storedCurrencyApplied ? (
        <RemoveAppliedGift
          applyGift={applyGift}
          loading={loading}
          storedCurrencyBalance={storedCurrencyUsage?.storedCurrencyBalance}
          storedCurrencyBalanceUsed={storedCurrencyUsage?.storedCurrencyBalanceUsed}
        />
      ) : (
        <AddGift
          applyGift={applyGift}
          loading={loading}
          setValue={setValue}
          storedCurrencyBalance={storedCurrencyUsage?.storedCurrencyBalance}
          value={value}
          error={error}
        />
      )}
    </Box>
  )
}

export default Gifts
